module.exports = __webpack_public_path__ + "img/16.1755de55.jpg";